import { render, staticRenderFns } from "./TablePersonSelectedIpt.vue?vue&type=template&id=32f9f058&scoped=true"
import script from "./TablePersonSelectedIpt.vue?vue&type=script&lang=js"
export * from "./TablePersonSelectedIpt.vue?vue&type=script&lang=js"
import style0 from "./TablePersonSelectedIpt.vue?vue&type=style&index=0&id=32f9f058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f9f058",
  null
  
)

export default component.exports